<template>
    <v-content pa-0>
        <nav
            id="navBar"
            style="background-color: white"

        ><!--            v-if="$vuetify.breakpoint.mdAndUp"-->
            <v-layout class="mt-1">
                <v-flex pa-3 >
                    <img :src="require('../assets/image62.png')" />
                </v-flex>
<!--                <v-flex style="width: 300px">-->
<!--                    <v-btn-->
<!--                            x-large-->
<!--                            color="#006738"-->
<!--                            text-->
<!--                            class="mt-5"-->
<!--                            style="text-align: center"-->

<!--                    >-->
<!--                        <div style="font-size: 16px;line-height: 24px">เข้าสู่ระบบ</div>-->
<!--                    </v-btn>-->
<!--                    <v-btn-->
<!--                            x-large-->
<!--                            color="#006738"-->
<!--                            dark-->
<!--                            class="mt-5"-->
<!--                            style="text-align: center;border-radius: 3px;"-->
<!--                    >-->
<!--                        <div style="font-size: 16px;line-height: 24px">ลงทะเบียน</div>-->
<!--                    </v-btn>-->
<!--                </v-flex>-->
            </v-layout>
        </nav>

<!--        <v-layout-->
<!--            v-else-->
<!--            justify-start-->
<!--            style="width: 100%;height: 78px"-->
<!--            :style="{ 'background': curScrollPos > 410 ? 'rgba(255,255,255,.9)':'transparent' }"-->
<!--        >-->
<!--            <v-flex shrink>-->
<!--                <v-btn-->
<!--                        absolute-->
<!--                        fab-->
<!--                        class="ml-2 mt-3"-->
<!--                        style="min-width: unset; box-shadow: unset; background: transparent"-->
<!--                        @click="drawer = !drawer"-->
<!--                >-->
<!--                    <v-icon large color="#006738">dehaze</v-icon>-->
<!--                </v-btn>-->
<!--            </v-flex>-->
<!--        </v-layout>-->
<!--        <v-navigation-drawer-->
<!--            v-model="drawer"-->
<!--            absolute-->
<!--            height="200vh"-->
<!--            style="z-index: 100;background: whitesmoke"-->
<!--        >-->
<!--        </v-navigation-drawer>-->
    </v-content>
</template>

<script>
    export default {
        name: "Header2",
        data: () => ({
            curScrollPos: null,
            drawer: false
        })

    }
</script>

<style scoped>

</style>
